import React from 'react';
import { ClickButton, OnOffSwitch } from '../base/ui';
export const RaiseHandToggle = React.memo(({ isShow, isRole, setIsShow }) => {
    const label = isShow ? 'ON' : 'OFF';
    if (!isRole) {
        return React.createElement(ClickButton, { className: "isFocus disable", isText: true, label: label });
    }
    return React.createElement(OnOffSwitch, { label: label, isShow: isShow, handlerClick: setIsShow });
});
